(function () {
  function init() {
    if (!document.body.classList.contains('template-index')) return;

    const headerElement = document.querySelector('sticky-header header');
    if (!headerElement) return;

    const isMobile = window.innerWidth <= 749;

    const categoriesSection = document.querySelector('.categories-list-section');
    const swiperIsActive = categoriesSection && categoriesSection.classList.contains('swiper-slide');

    if (swiperIsActive) {
      // On mobile, the mosaic is display:none but still counts as a Swiper slide —
      // remove it from Swiper so it doesn't consume a swipe.
      if (isMobile) {
        const mosaicSlide = document.querySelector('.brokn-mosaic-section');
        const swiperEl = document.querySelector('.slider-demo');
        const sw = swiperEl && swiperEl.swiper;
        if (mosaicSlide && sw) {
          const idx = Array.from(sw.slides).indexOf(mosaicSlide);
          if (idx !== -1) sw.removeSlide(idx);
        }
      }

      function checkActiveSlide() {
        const activeSlide = document.querySelector('.swiper-slide-active');
        if (!activeSlide) {
          headerElement.classList.remove('force-dark-logo');
          return;
        }
        const isDark =
          activeSlide.classList.contains('categories-list-section') ||
          !!activeSlide.querySelector('.brokn-footer-bar') ||
          (!isMobile && activeSlide.classList.contains('brokn-mosaic-section'));
        headerElement.classList.toggle('force-dark-logo', isDark);
      }

      const allSlides = document.querySelectorAll('.slider-demo .swiper-slide');
      const mo = new MutationObserver(checkActiveSlide);
      allSlides.forEach((s) => mo.observe(s, { attributes: true, attributeFilter: ['class'] }));
      checkActiveSlide();

    } else {
      const darkElements = [
        document.querySelector('.categories-list'),
        document.querySelector('.brokn-footer-bar'),
      ].filter(Boolean);

      if (!darkElements.length) return;

      const h = 90;
      function update() {
        const isDark = darkElements.some((el) => {
          const r = el.getBoundingClientRect();
          return r.top <= h && r.bottom > h;
        });
        headerElement.classList.toggle('force-dark-logo', isDark);
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      setInterval(update, 100);
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
